export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_15-8032f4137e4c91fe37c7802eccb91157.jpg";